module.exports = __webpack_public_path__ + "img/Bodyswaps_NO_mark.4a5cd9da.svg";